<template>
    <div id="products" class="features wow fadeInDown">
        <div class="container-m">
            <div class="row text-center">
                <div class="col-md-12">
                <div class="features-intro">
                    <h2>Resume_</h2>
                    <p>I have a degree in systems engineering and a passion for start-ups, I'm lucky because I work doing what I love, I do software development based on agile principles (Lean, Scrum, etc), and good practices (SOLID). I usually work with Vue.js, Laravel, AWS and others. I like to learn new things all the time.</p>
                </div>
                </div>
                <div class="col-md-6 col-lg-4">
                <div class="feature-list">
                    <div class="card-icon">
                    <div class="card-img">
                        <img src="@/assets/icons/code-slash-outline.svg" width="35" alt="Feature">
                    </div>
                    </div>
                    <div class="card-text">
                    <h3>Web Application Development</h3>
                    <p>Web services [Apis] and complex Internet-oriented solutions.</p>
                    </div>
                </div>
                </div>
                <div class="col-md-6 col-lg-4">
                <div class="feature-list">
                    <div class="card-icon">
                    <div class="card-img">
                        <img src="@/assets/icons/cloud-done-outline.svg" width="35" alt="Feature">
                    </div>
                    </div>
                    <div class="card-text">
                    <h3>Cloud Software Architecture Design</h3>
                    <p>Escalation of services with high demand.</p>
                    </div>
                </div>
                </div>
                <div class="col-md-6 col-lg-4">
                <div class="feature-list">
                    <div class="card-icon">
                    <div class="card-img">
                        <img src="@/assets/icons/rocket-outline.svg" width="35" alt="Feature">
                    </div>
                    </div>
                    <div class="card-text">
                    <h3>Deployment and Maintenance</h3>
                    <p>Successful launch of new internet products.</p>
                    </div>
                </div>
                </div>
                <div class="col-md-6 col-lg-4">
                <div class="feature-list">
                    <div class="card-icon">
                    <div class="card-img">
                        <img src="@/assets/icons/pulse-outline.svg" width="35" alt="Feature">
                    </div>
                    </div>
                    <div class="card-text">
                    <h3>Management Cloud Monitoring</h3>
                    <p>Alarms, alerts and performance indicators.</p>
                    </div>
                </div>
                </div>
                <div class="col-md-6 col-lg-4">
                <div class="feature-list">
                    <div class="card-icon">
                    <div class="card-img">
                        <img src="@/assets/icons/flask-outline.svg" width="35" alt="Feature">
                    </div>
                    </div>
                    <div class="card-text">
                    <h3>Product Discovery [ R&D ]</h3>
                    <p>Data-driven research and experimentation.</p>
                    </div>
                </div>
                </div>
                <div class="col-md-6 col-lg-4">
                <div class="feature-list">
                    <div class="card-icon">
                    <div class="card-img">
                        <img src="@/assets/icons/sync-outline.svg" width="35" alt="Feature">
                    </div>
                    </div>
                    <div class="card-text">
                    <h3>Agile Development</h3>
                    <p>Agile principles and values, iterative increment (Lean, Scrum, XP).</p>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'Resumen',
  components: {
  }
}
</script>

<style lang="stylus">
    @media only screen and (min-width: 240px)
        .features
            padding: 100px 0
            background: #f6f6fd
        .features-intro
            margin-bottom: 50px
            h2
                font-size: 28px
                font-weight: 600
                color: #3a3a47
                line-height: 1.3
                margin-bottom: 10px
            p
                font-size: 16px
                font-weight: 500
                line-height: 1.6
                letter-spacing: 0.01em
                color: #818198
                margin: 0 auto
                margin-top: 15px
                margin-bottom: 15px
        .feature-list 
            margin: 30px 10px
        .card-icon
            width: 65px
            height: 65px
            border-radius: 50%
            margin: 0 auto
            background: rgba(30, 166, 154, 0.08)
            background: #ece7fe
            display: table
            text-align: center
        .card-img
            display: table-cell
            vertical-align: middle
            text-align: center
            img
                vertical-align: middle
        .card-text
            margin-top: 25px
            h3
                font-size: 21px
                font-weight: 500
                color: #364655
                margin-bottom: 15px
            p
                font-size: 15px
                font-weight: 500
                color: rgb(129, 129, 152)
                line-height: 1.6
                max-width: 320px
                margin: 0 auto
</style>